// extracted by mini-css-extract-plugin
export default {"container":"Category_container__zw9Zu","load-button":"Category_load-button__Q-2BM"};